import { VisiblityElement } from '../visibility/visibility'

/**
 * Opens an <x-modal> that is not an ancestor of the trigger.
 *
 * ModalElement binds `data-modal-role="open"` on its own descendants only (`this.querySelectorAll`
 * in `fetchChildren`), so a button that sits outside the modal it targets is never wired up. That
 * is the case for the mini cart bag button, which lives in the header while the panel is rendered
 * by the `layout-minicart` section group.
 *
 * Dispatching the document-level show event is the same channel `Cart.dispatchOpenMiniCart()`
 * already uses, so an external trigger and an add-to-cart open the drawer identically.
 *
 * Usage:
 *   <x-modal-trigger class="contents" data-target="mini-cart"><button …></button></x-modal-trigger>
 *
 * `data-target` must match the target modal's `data-id`. Give the host `class="contents"` where it
 * sits in a flex or grid row, so it generates no box of its own.
 */
class ModalTriggerElement extends HTMLElement {
  connectedCallback() {
    this.handleClick = this.handleClick.bind(this)
    this.addEventListener('click', this.handleClick)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick)
  }

  handleClick(event) {
    const target = this.dataset.target
    if (!target) return
    event.preventDefault()
    VisiblityElement.dispatchShow(target)
  }
}

customElements.define('x-modal-trigger', ModalTriggerElement)
